import {
  SocketMessageInterface,
  DeviceViewDataByServerInterface,
  DeviceViewDataByBankInterface,
  LayoutInterface,
  FaultConfigurationInterface,
} from "../interfaces/Monitoring.interface";
import PositionCallsStatusT from "../types/PositionCallsStatus";
import { EMPTY_UUID } from "../utils/uuid";
import { EncodedMessageContent } from "../flatbuffers/generated/ln2/encoded-message-content";

const DEFAULT_BITMASK_MESSAGE_TYPE = 0;

export const DEFAULT_FAULTS_CONFIGURATION: FaultConfigurationInterface = {
  showCounter: false,
  rules: [],
};

export const SERVICE_MODE_COLORS: any = {
  ENERGY: "green",
  EMERGENCY: "red",
  NORMAL: "blue",
  INSPECTION: "geekblue",
  FIRE: "volcano",
  MAINTENANCE: "orange",
  OUT_OF_SERVICE: "magenta",
  TEST: "lime",
  CALL_OVERRIDE: "purple",
  VIP: "gold",
  SECURITY_LOCK: "cyan",
  LOBBY_RETURN: "blue",
  PARKED: "default",
  AUTO: "cyan",
};

export const BLANK_SOCKET_MESSAGE: SocketMessageInterface = {
  bankId: EMPTY_UUID,
  liftId: EMPTY_UUID,
  serviceMode: null,
  direction: null,
  carCalls: new PositionCallsStatusT(),
  connected: false,
  hallCalls: {
    up: new PositionCallsStatusT(),
    down: new PositionCallsStatusT(),
    upAssigned: new PositionCallsStatusT(),
    downAssigned: new PositionCallsStatusT(),
  },
  position: 0,
  faults: false,
  activeFaults: [],
  doorStatus: {
    frontOpen: false,
    rearOpen: false,
    frontStalled: false,
    rearStalled: false,
  },
  doorZone: null,
  levelling: false,
  escalatorControl: null,
  msg: {
    contentType: EncodedMessageContent.BitMaskMessage,
    messageType: DEFAULT_BITMASK_MESSAGE_TYPE,
    content: null,
    active: false,
  },
  bitmask: {},
  positionMap: {},
  serviceMap: {},
};

export const BLANK_DEVICE_VIEW_DATA_BY_SERVER: DeviceViewDataByServerInterface = {
  idServer: "",
  nameServer: "",
  lifts: [],
  liftsChunks: [],
};

export const BLANK_DEVICE_VIEW_DATA_BY_BANK: DeviceViewDataByBankInterface = {
  idBank: "",
  nameBank: "",
  lifts: [],
  liftsChunks: [],
};

export const BLANK_LAYOUT: LayoutInterface = {
  value: "",
  label: "",
  children: [],
  type: "",
  idOrganization: "",
  idServer: "",
  idChannel: "",
  idBank: "",
  nameOrganization: "",
  nameServer: "",
  nameChannel: "",
  typeChannel: "",
  id: "",
  active: false,
  board: 0,
  columns: 0,
  floor_below_lobby: 0,
  floor_count: 0,
  logical_port: 0,
  name: "",
  number_of_lifts: 0,
  channel_id: "",
  rear_doors: false,
  stops: 0,
  control_panel: {},
  bank_floors: [],
  lifts: [],
  floorsInUse: [],
  i: "",
  x: 0,
  y: 0,
  w: 0,
  h: 0,
  l: 0,
  f: 0,
  floor: 0,
  start_floor_no: 1,
  fbEnabled: true,
  cmdBinaryControl: false,
};
